import { IonIcon } from '@ionic/react'
import * as Sentry from '@sentry/react'
import { warningOutline } from 'ionicons/icons'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { Description, Title, Wrapper } from './styled'

type Props = {
  children: React.ReactNode
}

function ErrorFallback() {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Title>{t('alert.page error')}</Title>
      <Description>{t('alert.page error instruction')}</Description>
      <Button
        variant='warningBorder'
        onClick={() => window.location.reload()}
        endDecorator={
          <IonIcon
            icon={warningOutline}
            style={{ color: myPalette.orange.main }}
          />
        }
      >
        {t('button.refresh')}
      </Button>
    </Wrapper>
  )
}

export function ErrorBoundary(props: Props) {
  const { children } = props
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  )
}
